import React, { useState, useEffect } from "react";
import styles from "./ForgotPasswordModal.module.css";

function ForgotPasswordModal({ isOpen, onClose, onSubmit }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Handle escape key press
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, onClose]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const response = await onSubmit(email);
    if (response?.response?.data?.error) {
      setIsLoading(false);
      setError(response.response.data.error);
    } else {
      setEmail(""); // Clear input after successful submit
      setError("");
      setIsLoading(false);
    }
  };

  // Handle click outside modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className={styles.modalOverlay}
      onClick={handleOverlayClick}
      role="dialog"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      data-testid="forgot-password-modal"
    >
      <div className={styles.modalContent}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>

        <h2 id="modal-title">Password Reset</h2>

        <p id="modal-description" className={styles.instructions}>
          Please enter your username or email address below. If the account
          exists in our system, you will receive password reset instructions via
          email.
        </p>

        {error && (
          <div className={styles.errorMessage} data-testid="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label htmlFor="reset-email">Username/Email:</label>
            <input
              type="text"
              id="reset-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              aria-describedby="modal-description"
              data-testid="reset-email-input"
            />
          </div>

          <div className={styles.buttonGroup}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`${styles.submitButton} ${
                isLoading ? styles.loading : ""
              }`}
              disabled={isLoading}
              data-testid="submit-button"
            >
              {isLoading ? "Sending..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPasswordModal;
